import React, { useState, useEffect } from 'react';
import FullscreenLoader from '../FullscreenLoader';
import { queuedApiFetch, apiFetch } from '../api';
function Profile() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const getUserEmail = localStorage.getItem('userEmail');
    const [showOptions, setShowOptions] = useState(false);
    
    const getProjectDetails = localStorage.getItem('projectDetails');
    const selectedProjectDetail = JSON.parse(getProjectDetails);

    let user_company = JSON.parse(localStorage.getItem("userCompany"));
    let nus_sts = (user_company === "NUS") ? 1 : 0;
    let p_access = selectedProjectDetail?.Proj_Access?.proj_access_level;
    let p_roles = selectedProjectDetail?.Proj_Access?.proj_role.join(", ");
    p_roles = p_roles ? p_roles : '';
    let proj_name=selectedProjectDetail?.projectName;
    proj_name = proj_name ? proj_name : '';

    let qs_params = `nususer=${nus_sts}&project_admin=${(p_access) ? 1 : 0}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;
    const acc_url=`https://acc.autodesk.com/projects?${qs_params}`;

    const getUserDetails = () => {
        setLoading(true);
        const requestOptions = {
            method: 'GET',
            //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
        };

        queuedApiFetch('/user/getuserprofile?emailid='+getUserEmail, requestOptions)
            .then((response) => response)
            .then((data) => {
                if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
                    setRows(data.data);
                }
            })
            .catch((error) => console.error('Error fetching data:', error))
            .finally(() => setLoading(false));
    };
    useEffect(() => {
        getUserDetails();
    }, []);

    const toggleOptions = (event) => {
        event.stopPropagation();
        setShowOptions(prevShowOptions => !prevShowOptions);
      };
    return (
        <div className="wbshor">
            <div className="login-header-wrap">
                <div className="login-header">
                    <div className="pagetitle">{rows.user_name}</div>
                    <div className="button-wrapper">
                        {/* <button className="btntopright" id="optionsBtn" onClick={toggleOptions}><p>&lt;</p></button> */}
                        {showOptions && (
                        <div className="options-popup" id="optionsPopup" style={{ display: 'flex' }}>
                            <button className="option-btn yellow">Filter ↓</button>
                            <button className="option-btn">Export report ↓</button>
                            <button className="option-btn">Hide Columns ↓</button>
                        </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="bodywrap">
                {loading && <FullscreenLoader />} 
                    <div className="header">
                        <div className="projectwrap">
                        <button id="submit" onClick={() => window.location.replace(acc_url)}>Access ACC</button>
                        </div>
                    </div>
                    <div className="tablewrap">
                        <div id="20240906 custom table EDIT_18834" style={{marginTop:'20px'}}>
                            <div className="tablewrap">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Name</td>
                                            <td>{rows.user_name}</td>
                                        </tr>
                                        <tr>
                                            <td>Status</td>
                                            <td>{rows.user_status}</td>
                                        </tr>
                                        <tr>
                                            <td>Company</td>
                                            <td>{rows.company_name}</td>
                                        </tr>
                                        <tr>
                                            <td>Default role</td>
                                            <td>{rows.role_name}</td>
                                        </tr>
                                        <tr>
                                            <td>Access level</td>
                                            <td>{rows.access_level}</td>
                                        </tr>
                                        <tr>
                                            <td>Added on</td>
                                            <td>{rows.added_on}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Profile;
